export const localDataStore = (
  search,
  selectedContents,
  formik,
  table,
  page
) => {
  if (page === "collection") {
    localStorage.setItem("Is_collection", true);
  }
  if (page === "digital") {
    localStorage.setItem("Is_digital", true);
  }
  if (page === "conservation") {
    localStorage.setItem("Is_conservation", true);
  }
  if (page === "globalsearch") {
    localStorage.setItem("Is_globalsearch", true);
  }
  if (page === "admin") {
    localStorage.setItem("Is_admin", true);
  }
  if (page === "digital_kanban") {
    localStorage.setItem("Is_digital_kanban", true);
  }
  if (page === "conservation_kanban") {
    localStorage.setItem("Is_conservation_kanban", true);
  }
  if (page === "objectPin") {
    localStorage.setItem("IsObjectPin", true);
  }
  if (table === true) {
    localStorage.setItem("Is_table", true);
  }
  localStorage.setItem("typed_value", search);
  localStorage.setItem("selectedContents", JSON.stringify(selectedContents));
  localStorage.setItem("selectedFormik", JSON.stringify(formik?.values));
};
